<template>
    <div id="app">
        <main-nav v-bind:mobile="cards_mobile_active"></main-nav>
        <div id="site_wrap" v-bind:class="{ card_active: card_active }">

            <img id="intro_animation" src="./assets/img/intro_animation.gif" />
            <img id="intro_animation_mobile" src="./assets/img/intro_animation_mobile.gif" />

            <div id="landing_intro" class="container">
                <div class="row">
                    <div class="col-md-12">
                        <p id="landing_intro_text" class="large">Ready or not, summer is here. The season we dream about all through childhood has much more than sunshine and sand to offer. We're giving you something fun to try every day, so spend your summer with us!</p>
                        <img v-on:click="scroll_to_grid" id="landing_intro_chevron" src="./assets/img/chevron_down.svg" />
                        <button id="open_cards_mobile" v-on:click="cards_mobile_active = true">let's go!</button>
                    </div>
                </div>
            </div>
            <card-grid v-bind:cards="cards" v-on:cardopen="set_active"></card-grid>
            <cards-mobile v-bind:cards="cards" v-bind:active="cards_mobile_active"></cards-mobile>
        </div>
        <router-view v-on:cardopen="set_active"></router-view>
    </div>
</template>

<script>
import MainNav from './components/main-nav';
import CardGrid from './components/card-grid';
import CardOpen from './components/card-open';
import CardsMobile from './components/cards-mobile';
import 'font-awesome/css/font-awesome.css';
import * as contentful from 'contentful';
import anime from 'animejs';

export default {
  name: 'app',
  components: {
      MainNav,
      CardGrid,
      CardOpen,
      CardsMobile
  },
  data: function() {
      return {
          card_active: false,
          cards_mobile_active: false,
          cards: [],
          intro_ga: false,
          grid_ga: false,
          footer_ga: false
      }
  },
  methods: {
      set_active(val) {
          this.card_active = val;

		  if (window.innerWidth < 800) {
			  this.cards_mobile_active = true;
		  }
      },
      scroll_to_grid: function(e) {
          let grid = document.getElementById('card_grid');
          let scroll_y = this.get_scroll_distance(grid);
          anime({
              targets: 'html, body',
              scrollTop: scroll_y - 55,
              easing: 'easeOutQuart'
          });
    },
    get_scroll_distance: function(element) {
        var yPos = 0;

        while(element) {
            yPos += (element.offsetTop);
            element = element.offsetParent;
        }

        return yPos;
    }
  },
  mounted: function() {
      // Google analytics
      ga('create', 'UA-315022-1', 'auto');
      ga('send', 'pageview', '/');

      let client = contentful.createClient({
         space: 'r1t1gplw57al',
         accessToken: 'f2c158bbed860f1ac464cb5125c20db8749dc863c701adcec51b442529c97794'
      });

      client.getEntries({ content_type: 'card', limit: 1000, order: '-fields.cardNumber' }).then( (data) => {
          this.cards = data.items;
      });

      window.addEventListener('mousewheel', e => {
          if (this.card_active == true) {
              e.preventDefault();
          }
      });

      window.addEventListener('scroll', () => {

          let intro = document.getElementById('landing_intro_text');
          let intro_dimensions = intro.getBoundingClientRect();

          if (intro_dimensions.top < window.innerHeight && this.intro_ga == false) {
              ga('send', 'event', 'Bespoke 100 Days of Summer', 'section visible', 'intro');
              this.intro_ga = true;
          }

          let grid = document.getElementById('card_grid');
          let grid_dimensions = grid.getBoundingClientRect();

          if (grid_dimensions.top < window.innerHeight && this.grid_ga == false) {
              ga('send', 'event', 'Bespoke 100 Days of Summer', 'section visible', 'grid');
              this.grid_ga = true;
          }

          if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight && this.footer_ga == false) {
              ga('send', 'event', 'Bespoke 100 Days of Summer', 'section visible', 'footer');
              this.footer_ga = true;
          }
      });

      window.addEventListener('touchmove', e => {
          if (this.card_active == true) {
              e.preventDefault();
          }
      });

      anime({
          targets: '#landing_intro_chevron',
          translateY: [
              { value: [0, '-25px'], duration: 300, easing: 'easeOutQuad' },
              { value: 0, duration: 1200, elasticity: '700' },
              { value: 0, duration: 5000 }
          ],
          loop: true
      });
  }
}
</script>

<style lang="scss">
    @import './assets/scss/main.scss';

    body {
        height: 100%;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
    }

    #app {
        margin: 0 auto;
        margin-top: 55px;
    }

    #intro_animation {
        width: 100%;
    }

    #landing_intro_text {
        color: $pink;
        max-width: 550px;
        text-align: center;
        margin: 45px auto;
    }

    #landing_intro_chevron {
        margin: 0 auto;
        margin-bottom: 60px;
        cursor: pointer;
    }

    #intro_animation_mobile {
        display: none;
        width: 100%;
    }

    #open_cards_mobile {
        display: none;
        border-color: $pink;
        color: $pink;
        margin: auto;
        margin-bottom: 30px;

        &:hover {
            background-color: $pink;
            color: white;
        }
    }

    @media (min-width: $small-break) {
        #site_wrap {
            transition: filter 0.5s;
            &.card_active {
                filter: blur(5px);
            }
        }
    }

    @media (max-width: $small-break) {

        #app {
            margin-top: 50px;
        }

        #intro_animation {
            display: none;
        }

        #intro_animation_mobile {
            display: block;
        }

        #landing_intro {
            margin-top: 15px;
        }

        #landing_intro_text {
            margin-bottom: 15px;
            line-height: 1.5;
        }

        #landing_intro_chevron {
            display: none;
        }

        #open_cards_mobile {
            display: block;
        }

    }

    @media (max-height: 570px) {
        p.large {
            font-size: 14px;
        }
    }

</style>



// WEBPACK FOOTER //
// App.vue?5f6ebc68